import DoneIcon from "@mui/icons-material/Done";
import subjectSelectionService from "../../../../../services/subjectSelectionService";
import IconLock from "../../../../../assets/images/icons/circle-lock.svg?react";
import "./ReturningSubjectsButton.css";

const ReturningSubjectsButton = (props) => {
    const {
        subjectsSelected,
        subject,
        packageProduct,
        onSubjectClick,
        isHigherSelection,
    } = props;

    const {
        isLocked,
        isSelected,
        isDisabled,
    } = subjectSelectionService.getSubjectVariant(
        subject,
        packageProduct,
        subjectsSelected,
        isHigherSelection,
    );

    return (
        <button
            type="button"
            disabled={isLocked || (isSelected ? false : isDisabled)}
            className={`returning-subject-button ${isSelected ? "selected" : ""} ${isLocked ? "locked" : ""}`}
            onClick={() => onSubjectClick(subject)}
        >
            {isLocked ? <IconLock className="returning-subject-button__lock" /> : (
                <span className="returning-subject-button__indicator">
                    {isSelected && <DoneIcon />}
                </span>
            )}
            {subject.name}
        </button>
    );
};

export default ReturningSubjectsButton;
